/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpSharedDetail_detailValues$ref = any;
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
export type PdpRespDetails_item$ref = any;
export type PdpRespDetails_item = {
    readonly serviceId: string | null;
    readonly vertical: VerticalType | null;
    readonly pdpDetailsDisplay: ReadonlyArray<{
        readonly detailKey: string | null;
        readonly delimiter: string | null;
        readonly detailDisplayName: string | null;
        readonly detailValues: ReadonlyArray<{
            readonly " $fragmentRefs": PdpSharedDetail_detailValues$ref;
        } | null> | null;
    } | null> | null;
    readonly " $refType": PdpRespDetails_item$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespDetails_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "vertical",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "pdpDetailsDisplay",
      "storageKey": null,
      "args": null,
      "concreteType": "PdpDetail",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "detailKey",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "delimiter",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "detailDisplayName",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "detailValues",
          "storageKey": null,
          "args": null,
          "concreteType": null,
          "plural": true,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "PdpSharedDetail_detailValues",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = 'be2ef3d702ea5aa0d7d0fc2e778d6103';
export default node;
